import { createIcon } from '@chakra-ui/react';

export const PaymentOutlineIcon = createIcon({
  displayName: 'PaymentOutlineIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="16"
        // height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          d="M2.61963 11.0861L10.5863 3.11945"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.40088 12.686L8.20088 11.886"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.19531 10.8925L10.7886 9.29913"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.40101 7.32598L6.82768 2.89931C8.24101 1.48598 8.94768 1.47931 10.3477 2.87931L13.621 6.15265C15.021 7.55265 15.0143 8.25931 13.601 9.67265L9.17434 14.0993C7.76101 15.5126 7.05434 15.5193 5.65434 14.1193L2.38101 10.846C0.981009 9.44598 0.981009 8.74598 2.40101 7.32598Z"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.3335 15.1657H14.6668"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
